/**
 * billing_interval_controller.js — monthly/yearly price toggle (Stimulus).
 *
 * Ports the toggle behaviour out of plans.js's DOMContentLoaded block, which
 * never ran after a Turbo navigation (Turbo swaps <body> without a full page
 * load, so DOMContentLoaded only fires on a hard refresh). The result was a
 * dead Yearly toggle on the plans page when reached via an in-app link.
 *
 * One instance per .billing-toggle (data-controller="billing-interval"). The
 * price-switch CSS keys off body[data-billing-interval="annual"] (the .*-only
 * spans live in sibling plan cards, not inside the toggle), so the chosen
 * interval is mirrored onto document.body.
 *
 * Lifecycle: connect() syncs the body attribute to the checked radio;
 * disconnect() and a connect-scoped turbo:before-cache REMOVE it so the cached
 * snapshot matches the server render and the annual state can't leak onto the
 * next page. plans.js still owns checkout submission (getBillingInterval reads
 * the radio directly at submit time).
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this._sync();
        this._onBeforeCache = () => this._clear();
        document.addEventListener('turbo:before-cache', this._onBeforeCache);
    }

    disconnect() {
        if (this._onBeforeCache) {
            document.removeEventListener('turbo:before-cache', this._onBeforeCache);
            this._onBeforeCache = null;
        }
        this._clear();
    }

    // data-action="change->billing-interval#update"
    update() {
        this._sync();
    }

    _sync() {
        const checked = this.element.querySelector('input[name="billing_interval_choice"]:checked');
        document.body.dataset.billingInterval = checked ? checked.value : 'monthly';
    }

    _clear() {
        delete document.body.dataset.billingInterval;
    }
}
